// Renders KB article content: light markdown (## / ### headings, **bold**, - bullets,
// 1. numbered steps, ![alt](url) images) into styled React nodes.
function renderInline(text) {
  return String(text).split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
    p.startsWith("**") && p.endsWith("**")
      ? <strong key={i} className="text-zinc-100 font-semibold">{p.slice(2, -2)}</strong>
      : <span key={i}>{p}</span>);
}

export default function KBContent({ text }) {
  const lines = String(text || "").split("\n");
  const out = []; let bullets = null;
  const flush = () => { if (bullets) { out.push(<ul key={`ul${out.length}`} className="list-disc pl-5 space-y-1 my-2 text-zinc-300">{bullets}</ul>); bullets = null; } };
  lines.forEach((raw, i) => {
    const line = raw.replace(/\s+$/, "");
    const img = line.match(/^!\[([^\]]*)\]\(([^)]+)\)\s*$/);
    if (img) { flush(); out.push(<img key={i} src={img[2]} alt={img[1]} loading="lazy" className="w-full max-w-2xl rounded-md border border-zinc-800 my-4" />); return; }
    if (/^##\s+/.test(line)) { flush(); out.push(<h3 key={i} className="font-display text-[11px] uppercase tracking-[0.16em] text-blue-400 mt-5 mb-1">{renderInline(line.replace(/^##\s+/, ""))}</h3>); return; }
    if (/^###\s+/.test(line)) { flush(); out.push(<h4 key={i} className="font-medium text-zinc-200 mt-3">{renderInline(line.replace(/^###\s+/, ""))}</h4>); return; }
    if (/^[-*]\s+/.test(line)) { (bullets ||= []).push(<li key={i}>{renderInline(line.replace(/^[-*]\s+/, ""))}</li>); return; }
    if (/^\d+\.\s+/.test(line)) { flush(); const n = line.match(/^\d+\./)[0]; out.push(<div key={i} className="flex gap-2 my-0.5"><span className="text-zinc-500 font-mono shrink-0">{n}</span><span className="text-zinc-300">{renderInline(line.replace(/^\d+\.\s+/, ""))}</span></div>); return; }
    if (line.trim() === "") { flush(); out.push(<div key={i} className="h-2" />); return; }
    flush(); out.push(<p key={i} className="text-zinc-300 my-1">{renderInline(line)}</p>);
  });
  flush();
  return <div className="text-sm leading-relaxed">{out}</div>;
}
